import users from 'modules/core/store/collections/users'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import employees from 'modules/employees/store/collections/employees'
import type Employee from 'modules/employees/store/models/Employee'
import { workScheduleEmployees } from 'modules/work_schedules/lib/workScheduleEmployees'
import type Schedule from 'modules/work_schedules/store/models/Schedule'

import { selectableEmployeesByCurrent } from './selectableEmployeesByCurrent'

export const canAssignEmployees = (contractVersions: ContractVersions): boolean => {
  return (
    users.current.policy.can('workSchedule.manageCompanySchedules') &&
    !!selectableEmployeesByCurrent(contractVersions).length
  )
}

export const canReassignAllEmployees = (
  workSchedule: Schedule,
  noOfEmployees: number | [],
  contractVersions: ContractVersions
): boolean => {
  const allSelectableEmployees = new Set(selectableEmployeesByCurrent(contractVersions))

  const scheduleEmployees = workScheduleEmployees(workSchedule, employees)
  const scheduleSelectableEmployees = scheduleEmployees.filter((employee: Employee) =>
    allSelectableEmployees.has(employee)
  )

  // only if I have permission over all WS employees
  return (
    canAssignEmployees(contractVersions) && noOfEmployees === scheduleSelectableEmployees?.length
  )
}
